import sanitizeHtml from 'sanitize-html';
import { getLabelFromUrl } from '~/utils/urlHelpers'
export default defineNuxtPlugin(nuxtApp => {
  const dataAll = useDataAll()
  const runtimeConfig = useRuntimeConfig();

  // Use useState to share hostname between server and client
  const serverHostname = useState('server-hostname', () => null);

  const helpers = {
    arrVal(arrayObj, key, defaultValue, preString) {
      return helpers.isset(arrayObj[key]) ? preString + arrayObj[key] : defaultValue
    },
    isset(varIn) {
      return (typeof (varIn) != "undefined" && varIn !== null)
    },
    getLabelId() {
      let hostname = "";
      var sites = [];
      var sitesId = [];
      let dataAll = useDataAll();
      let runtimeConfigVars = []


      if (import.meta.client) {
        // If dataAll has a label, use it
        if (dataAll.getLabel()) {
          return dataAll.getLabel();
        }
        runtimeConfigVars = runtimeConfig.public
        // Use the server-side determined hostname if available
        hostname = serverHostname.value || dataAll.getDataVar('hostname');

        if (!hostname) {
          console.log("ERROR: No hostname available on client side");
          return "ERROR";
        }
        if (!helpers.isset(runtimeConfig.public.HOSTNAME_SITES) || !helpers.isset(runtimeConfig.public.LABELID_SITES)) {
          console.log("ERROR HOSTNAME_SITES NIET GEVONDEN IN public runtime config")
          return "ERROR"
        }

      } else {
        runtimeConfigVars = runtimeConfig
        if (!helpers.isset(runtimeConfig.HOSTNAME_SITES) || !helpers.isset(runtimeConfig.LABELID_SITES)) {
          console.log("ERROR HOSTNAME_SITES NIET GEVONDEN IN .env, WORDT DE .env FILE GOED INGELADEN")
          throw createError({ statusCode: 500, statusMessage: 'ERROR HOSTNAME_SITES1 NIET GEVONDEN IN .env, WORDT DE .env FILE GOED INGELADEN' })
        }
        const url = useRequestURL();
        hostname = url.hostname;

        // Store hostname in shared state for client-side use
        serverHostname.value = hostname;
        dataAll.setDataVar('hostname', hostname);


      }

      const labelId = getLabelFromUrl(hostname, runtimeConfig)
      if (labelId) {
        dataAll.setlabel(labelId);
        return labelId;
      } else {
        console.log("ERROR " + hostname + " NIET GEVONDEN IN HOSTNAME_SITES")
        return "ERROR"
      }
    },
    stripHtml(html, max = null) {
      if (!html) return ''
      let text = sanitizeHtml(html.replace(/<\/(p|div|li|h[1-6])>|<br\s*\/?>/gi, ' '), {
        allowedTags: [],
        allowedAttributes: {},
      })
      text = this.decodeEntities(text).replace(/\s+/g, ' ').trim()
      if (!max || text.length <= max) return text
      const cut = text.lastIndexOf(' ', max)
      return text.slice(0, cut > 0 ? cut : max) + '…'
    },
    decodeEntities(text) {
      return text
        .replace(/&#(\d+);/g, (_, n) => String.fromCodePoint(+n))
        .replace(/&#x([0-9a-f]+);/gi, (_, n) => String.fromCodePoint(parseInt(n, 16)))
        .replace(/&nbsp;/g, ' ')
        .replace(/&quot;/g, '"')
        .replace(/&(#39|apos);/g, "'")
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&amp;/g, '&') // als laatste, anders wordt &amp;lt; ten onrechte 
    },
  }
  nuxtApp.provide('helpers', helpers);
})
